import type { FaireProductEntity } from "../../entity_types/product";

export const p_k6se935ke8: FaireProductEntity = {
  token: "p_k6se935ke8",
  type: "product",
  name: "Single Origin African",
  brandToken: "b_cgzjcth7hb",
  brandName: "Four Barrel Coffee",
  imageUrl: "https://cdn.faire.com/fastly/64e47e56d550e488eb25e6f7216cb64e80fa2fcc127f651dd26162c8734cf5c3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/385997792ffc15592ab134291c44f9515e7ad4e364d21baf4a041b2ff081dca4.jpeg"
  ],
  priceDollars: 28,
  description: "Our menu is ever rotating and we always are roasting some beautiful and delicious coffees. Our single origin Africans come from Rwanda, Kenya, Ethiopia and is always rotating.\nPlease reach out if you are looking for a particular origin.\n\nTo check out our current offerings, please go to our website: www.fourbarrelcoffee.com.",
  tags: [],
  msrpDollars: 56,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:58:00.719Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
